import { MyFavourites, Menu, Notification, Notification2, HelpCenter, UserRoles } from './menu';



export const Menu1: Menu[] = [
    { id: 1, name: "Quick Delegation", url: '#' },
    { id: 2, name: "Advance Delegation", url: '#' },
    { id: 3, name: "SSD", url: '#' },
]

export const Menu2: Menu[] = [
    { id: 1, name: "Create New KIF ", url: '#' },
    { id: 2, name: "Help ", url: '#' },
    { id: 3, name: "E-learning module ", url: '#' },
    { id: 4, name: "Master Template ", url: '#' },
    { id: 5, name: "User Manual ", url: '#' },
    { id: 6, name: "Excalibur ", url: '#' },
    { id: 7, name: "Opportunity Details ", url: '#' },
]

export const Menu3: Menu[] = [
    { id: 1, name: "All Transaction InFlow Report", url: '#' },
    { id: 2, name: "Pending Sow Report with Ageing", url: '#' },
    { id: 3, name: "Periodic Report", url: '#' },
    { id: 4, name: "RiskScore Report", url: '#' },
    { id: 5, name: "Signed Transactions Report", url: '#' },
    { id: 6, name: "SLA Report", url: '#' },
]
export const Menu4: Menu[] = [
    { id: 1, name: "CCG Play Book", url: '#' },
    { id: 2, name: "Contact Admin Manual", url: '#' },
    {id: 3, name: "LKO Manual", url: '#'},
    {id: 4, name: "Master Template", url: '#'},
    {id: 5, name: "Requests Details", url: '#'},
    {id: 6, name: "User Manual", url: '#'},
    {id: 7, name: "Master templates", url: '#'}
]


/*my favourites*/
export const Favourite: MyFavourites[] = [
    { id: 1, name: "iTime (Time Sheet Management System)",icon: 'hdr-iTime', url: '#' },
    { id: 2, name: "India LMS",icon: 'hdr-lms', url: '#' },
    { id: 3, name: "iBridge",icon: 'hdr-iBridge', url: '#' },
    { id: 4, name: "Global Claims System",icon: 'hdr-gcs', url: '#' },
    { id: 5, name: "Transportal",icon: 'hdr-transportal', url: '#' },
    { id: 6, name: "My Travel (TAS)",icon: 'hdr-tas', url: '#' },
    { id: 7, name: "HCL Today",icon: 'hdr-hclToday', url: '#' },
    { id: 8, name: "My Approvals",icon: 'hdr-myApproval', url: '#' },
    { id: 9, name: "360 Degree - Smart Survey",icon: 'hdr-smartSurvey', url: '#' },
    { id: 10, name: "Smart Service Desk (SSD)",icon: 'hdr-ssd', url: '#' },
]

/*notification*/

export const Today: Notification[] = [
    {notificationText: "Notifications will visible here - 1", url: '#'},
    {notificationText: "Notifications will visible here - 2", url: '#'},
]

export const Older: Notification2[] = [
    {notificationText: "Notifications will visible here - 1", url: '#'},
    {notificationText: "Notifications will visible here - 2", url: '#'},
]

/* help center */

export const HelpTop: HelpCenter[] = [
    { id: 1,icon: 'hdr-userManual', name: "Help", url: '#' },
    // { id: 2,icon: 'hdr-faq', name: "FAQ's", url: '#' },
]

export const HelpBottom: HelpCenter[] = [
    { id: 1,icon: 'hdr-relaseNote', name: "Quick Delegation", url: '#' },
    { id: 2,icon: 'hdr-vendorStaff', name: "Advance Delegation", url: '#' },
    { id: 3,icon: 'hdr-rmDashboard', name: "SSD", url: '#' },
]

export const userRole: UserRoles[] = [
    { id: 1, name: "Employee", styleClass: 'active', url: '#' },
    { id: 2, name: "Approver",styleClass: 'active', url: '#' },
    {id: 3, name: "BPO Head",styleClass: 'active', url: '#'},
    {id: 4, name: "Admin",styleClass: 'active', url: '#'}
]